<p-sidebar  position="right" [(visible)]="display" [showCloseIcon]="false" (onHide)="onSlideBarClose()">
  <ng-template pTemplate="header">
    <div class="align-items-center flex justify-content-between w-full">
      <h2 class="gc-form-heading">Preferences</h2>
      <span (click)="onSlideBarClose()" class="cursor-pointer"><em class="pi pi-times"></em></span>
    </div>
  </ng-template>

<!-- form -->
<ng-template pTemplate="content">
  <div class="popup-wrapper">
    <div class="form-container">
     <form [formGroup] = "updateUserForm">
      <div class="gc-form-section">
        <div class="gc-form-section-heading">
          <h3>Personal Information</h3>
        </div>
       <div class="sidebar-form">
        <div  class="gc-profile-icon">
          <div class="gc-profile-wrap">
            <img [src]="updateUserForm.value?.picture ? updateUserForm.value?.picture : '../../assets/images/Subtract.svg'" alt="user-picture">
          </div>
          <div class="flex align-items-center gap-4">
            <p-fileUpload #fileUpload (onSelect)="onSelect($event)" [auto]="true" [chooseIcon]="null"
                          [maxFileSize]="1000000"
                          accept="image/*" [chooseLabel]="updateUserForm.value?.picture ? 'Update' : 'Update'" mode="basic" name="demo[]"
                          styleClass="change-img-btn"></p-fileUpload>
            <p-button *ngIf="updateUserForm.value?.picture" (click)="deleteFile()"
                      label="Remove" styleClass="button-sm remove-img-btn"></p-button>
          </div>
        </div>
        <div class="grid p-fluid">
          <div class="col-12 md:col-6">
            <label>First Name<span class="red">*</span></label>
            <span class="p-input-icon-left">
            <span class="gc-input-icon"><img src="../../assets/images/input-user.svg" alt="input-user.svg"></span>
            <input formControlName="firstName" id="firstName" name="name" pInputText
                  placeholder="Enter first name" type="text"/>
          </span>
          </div>

          <div class="col-12 md:col-6">
            <label>Last Name</label>
            <span class="p-input-icon-left">
            <span class="gc-input-icon"><img src="../../assets/images/input-user.svg" alt="input-user.svg"></span>
            <input formControlName="lastName" id="lastName" name="name" pInputText
                  placeholder="Enter last name" type="text"/>
          </span>
          </div>
        </div>

        <div class="grid p-fluid">
          <div class="col-12 md:col-6" formGroupName="phone">
            <label>Phone</label>
            <div class="flex gc-dialCode">
              <p-dropdown [options]="countries" optionValue="dial_code" optionLabel="dial_code" formControlName="countryCode">
                <ng-template pTemplate="selectedItem" let-country>
                  <span class="fi fi-{{country.code.toLowerCase()}} countryflag"></span>
                  <span class="country-code"> {{country.dial_code}}</span>
                </ng-template>
                <ng-template pTemplate="item" let-country>
                  <span class="fi fi-{{country.code.toLowerCase()}} countryflag"></span>
                  <span class="country-code"> {{country.dial_code}}</span>
                </ng-template>
              </p-dropdown>
              <p-inputMask mask="999-999-9999" formControlName="number" placeholder="(XXX) XXX-XXXX"></p-inputMask>
            </div>
          </div>

          <div class="col-12 md:col-6" formGroupName="fax">
              <label>Fax</label>
              <div class="flex gc-dialCode">
                <p-dropdown [options]="countries" optionValue="dial_code" optionLabel="dial_code" formControlName="countryCode" class="">
                  <ng-template pTemplate="selectedItem" let-country>
                    <span class="fi fi-{{country.code.toLowerCase()}} countryflag"></span>
                    <span class="country-code"> {{country.dial_code}}</span>
                  </ng-template>
                  <ng-template pTemplate="item" let-country>
                    <span class="fi fi-{{country.code.toLowerCase()}} countryflag"></span>
                    <span class="country-code"> {{country.dial_code}}</span>
                  </ng-template>
                </p-dropdown>
                <p-inputMask mask="999-999-9999" formControlName="number" placeholder="(XXX) XXX-XXXX"></p-inputMask>
              </div>
            </div>
        </div>
       </div>
      </div>

      <div class="gc-form-section">
        <div class="gc-form-section-heading">
          <h3>Set Password</h3>
        </div>
        <div class="sidebar-form">
          <div class="grid p-fluid">
            <div class="col-12 md:col-6">
              <label>Password<span class="red">*</span></label>
              <p-password [toggleMask]="true" [feedback] ="false" id="password" type="password"  formControlName="password"
                     name="password" placeholder="Password"></p-password>

            </div>
            <div class="col-12 md:col-6">
              <label>Confirm Password<span class="red">*</span></label>
              <p-password [toggleMask]="true" type="password" [feedback] ="false"  name="confirmPassword" formControlName="confirmPassword"
                      placeholder="Confirm Password"></p-password>
            </div>
          </div>
        </div>
      </div>

     </form>
    </div>
  </div>
</ng-template>
<ng-template pTemplate="footer">
  <div class="gc-slide-footer flex justify-content-end gap-4">
    <button class="btn-cancel" pButton label="Cancel" (click)="onSlideBarClose()"></button>

    <button type="submit" pButton label="Update" (click)="updateUserPreferences()"
    [disabled]="!updateUserForm.valid ||
              !(this.updateUserForm.value.password == this.updateUserForm.value.confirmPassword)"
           ></button>

  </div>
</ng-template>
</p-sidebar>
